import React from "react";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { Button } from "./UI";
import Modal from "./UI/modal/Modal";
import * as commonData from "../Common";

const CtaComponent = ({ cta, callCtaActionHandler }) => {
  const params = useParams();
  const [state, setState] = useState({
    cta,
    isModalClose: false,
    ctaItem: {},
  });

  const modalCloseHandler = () => {
    setState((state) => {
      return {
        ...state,
        isModalClose: false,
      };
    });
  };
  const ctaActionHandler = (item) => {
    setState((state) => {
      return {
        ...state,
        isModalClose: true,
        ctaItem: item,
      };
    });
  };

  const confirmCtaHandler = () => {
    let ctaActionDetails = {
      cta_id: state.ctaItem.id,
      user_uuid: commonData.getCommonData().user_uuid,
      customer_tattle_uuid: Number(params.id),
    };
    let resp = callCtaActionHandler(state.ctaItem.api_url, ctaActionDetails);
  };
  return (
    <>
      <Modal
        show={state.isModalClose}
        className="confirm"
        close={modalCloseHandler}
      >
        <div className="actionDelete">
          <p>{state.ctaItem.message}</p>
          <Button
            className="muBtn _blue"
            text="Yes"
            onClick={confirmCtaHandler}
          />{" "}
          &nbsp;
          <Button
            className="muBtn _grey"
            text="Cancel"
            onClick={modalCloseHandler}
          />
        </div>
      </Modal>
      {state.cta.map((item) => (
        <span onClick={() => ctaActionHandler(item)} className="cta">
          {item.field_name}
        </span>
      ))}
    </>
  );
};

export default CtaComponent;
